import * as React from "react";
import { type IColumn } from "@fluentui/react";
import { makeObservable, computed } from "mobx";
import { observer } from "mobx-react";
import { type UUID } from "../../utils/uuid";
import { type PreOpsQuestion } from "../../api";

export interface ListPreOpsChecklistItemCellProps {
    readonly preOpsQuestionId: UUID;
    readonly column: IColumn;
}

import { store } from "../../store";

@observer
export class ListPreOpsChecklistItemCell extends React.Component<ListPreOpsChecklistItemCellProps> {
    constructor(props: ListPreOpsChecklistItemCellProps) {
        super(props);
        makeObservable(this);
    }

    @computed private get preOpsQuestion(): PreOpsQuestion | undefined {
        return store.repositoryPreOpsQuestions.byId(this.props.preOpsQuestionId);
    }

    public render(): JSX.Element {
        const { column } = this.props;
        const { position, body, kind } = this.preOpsQuestion!;
        switch (column.key) {
            case "position":
                return (
                    <span>
                        {store.i18n.t("listPreOpsChecklist.questionPosition.name", {
                            position,
                        })}
                    </span>
                );
            case "body":
                return <span style={{ whiteSpace: "pre-wrap" }}>{body}</span>;
            case "kind":
                return (
                    <span style={{ whiteSpace: "pre-wrap" }}>
                        {store.i18n.t(`formCreatePreOpsChecklist.responseOptions.${kind}`)}
                    </span>
                );
            default:
                return <></>;
        }
    }
}
